module.exports = __webpack_public_path__ + "img/eraser.dad3ccab.svg";